<sgt-autocomplete
  [selectedItem]="{
    id: selectedCliente?.id,
    label: selectedCliente?.nome
  }"
  [settings]="settings"
  (changed)="onSearchCliente($event)"
>
  <ng-container item *ngIf="clientes && clientes.length">
    <li
      *ngFor="let cliente of clientes"
      class="autocomplete__item"
      (click)="onSelectCliente(cliente)"
    >
      <div class="d-flex justify-content-between align-items-start w-100">
        <div class="d-flex flex-column">
          <span>{{ cliente?.codigo }} - {{ cliente?.nome }}</span>
          <small>{{ cliente?.nomeFantasia }} - {{ cliente?.nomeCidade }} - {{ cliente?.uf }}</small>
        </div>

        <div class="d-flex flex-column align-items-end">
          <span [ngClass]="cliente.cssClassCadastro">{{ cliente.cadastroLabel }}</span>
          <span class="mt-1" [ngClass]="cliente.cssClassSituacao">{{ cliente.situacaoLabel }}</span>
        </div>
      </div>
    </li>
  </ng-container>

  <div class="mt-2" info *ngIf="selectedCliente">
    <div class="form-text text-muted d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span>
          <strong>Código:</strong> {{ selectedCliente?.codigo }}
        </span>
        <span>
          <strong>Nome:</strong> {{ selectedCliente?.nome }}
        </span>
        <span>
          <strong>Nome Fantasia:</strong> {{ selectedCliente?.nomeFantasia }}
        </span>
        <span>
          <strong>Cidade:</strong> {{ selectedCliente?.nomeCidade }} - {{ selectedCliente?.uf }}
        </span>
      </div>

      <div class="d-flex flex-column">
        <span
          [style.color]="selectedCliente.cssClassCadastro"
          [ngClass]="selectedCliente.cssClassCadastro"
        >
          {{ selectedCliente.cadastroLabel }}
        </span>
        <span
          class="mt-1"
          [style.color]="selectedCliente.cssClassSituacao"
          [ngClass]="selectedCliente.cssClassSituacao"
        >
          {{ selectedCliente.situacaoLabel }}
        </span>
      </div>
    </div>
  </div>
</sgt-autocomplete>
